import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import Grid from '@material-ui/core/Grid';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { injectIntl } from 'react-intl';
import { Checkmark, Facesheet, Launch, Printer } from '@mummssoftware/icons';
import { actionIconStyle as actionIcons } from '../style/ThemeProvider/commonStyles';
import { ActionIcon } from '../ActionIcon';
import messages from './messages';
const NavHeaderIcon = withStyles(({
  palette,
  props
}) => createStyles({
  actionIcons,
  actionItems: _objectSpread({
    paddingRight: 2,
    '&:not(:last-child) $actionIcons:after': {
      borderRight: `1px solid ${palette.background.header}`,
      content: '" "',
      height: 16,
      position: 'absolute',
      right: -3
    }
  }, props.printRules.hide),
  mobileNavIcon: {
    height: 40
  },
  mobileIcons: {
    width: 40,
    height: 40,
    padding: 0,
    marginTop: 5
  },
  mobileItems: _objectSpread({
    flex: '0 1 auto',
    margin: '0 auto'
  }, props.printRules.hide)
}))((_ref) => {
  let {
    classes,
    isMobile,
    iconProps: {
      className: iconClassName
    } = {
      className: ''
    }
  } = _ref,
      iconProps = _objectWithoutProperties(_ref.iconProps, ["className"]),
      props = _objectWithoutProperties(_ref, ["classes", "isMobile", "iconProps"]);

  return /*#__PURE__*/React.createElement(Grid, {
    item: true,
    className: isMobile ? classes.mobileItems : classes.actionItems
  }, /*#__PURE__*/React.createElement(ActionIcon, _extends({}, props, {
    classes: {
      root: isMobile ? classes.mobileIcons : classes.actionIcons
    },
    iconProps: _objectSpread({
      className: isMobile ? `${classes.mobileNavIcon} ${iconClassName || ''}` : iconClassName
    }, iconProps)
  })));
});
export const CloseButton = withStyles({
  closeIcon: {
    height: '15px'
  }
})(injectIntl(({
  showClose,
  closeForm,
  intl: {
    formatMessage
  },
  classes
}) => showClose ? /*#__PURE__*/React.createElement(NavHeaderIcon, {
  title: formatMessage(messages.close),
  Icon: Checkmark,
  onClick: closeForm,
  iconProps: {
    className: classes.closeIcon
  }
}) : null));
/** @component */

export const CardHeaderNav = withStyles(({
  props
}) => createStyles({
  mobileGridStyle: {
    height: `calc(50px + var(--safe-area-inset-bottom))`,
    backgroundColor: 'rgba(0, 0, 0, 0.45)'
  },
  root: props.printRules.hide
}))(injectIntl(({
  classes,
  enableClinicalLinks,
  m2Url,
  patient,
  intl: {
    formatMessage
  },
  showClose,
  closeForm,
  printFn,
  isMobile
}) => /*#__PURE__*/React.createElement(Grid, {
  container: true,
  className: isMobile ? `${classes.mobileGridStyle} ${classes.root}` : classes.root,
  justify: "center",
  spacing: 0
}, enableClinicalLinks && /*#__PURE__*/React.createElement(NavHeaderIcon, {
  title: formatMessage(messages.chart),
  Icon: Launch,
  target: "__blank",
  href: m2Url('patient', patient.patientNumber, '?render=mid-ui'),
  isMobile: isMobile
}), /*#__PURE__*/React.createElement(NavHeaderIcon, {
  title: formatMessage(messages.facesheet),
  Icon: Facesheet,
  target: "__blank",
  href: `${patient.facesheetURL}?print=off`,
  isMobile: isMobile
}), /*#__PURE__*/React.createElement(NavHeaderIcon, {
  isMobile: isMobile,
  title: formatMessage(messages.print),
  Icon: Printer,
  onClick: typeof printFn === 'function' ? printFn : window.print
}), /*#__PURE__*/React.createElement(CloseButton, {
  closeForm: closeForm,
  showClose: showClose
}))));
export default CardHeaderNav;